var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-tab-panel',[_c('dx-item',{attrs:{"title":"Fundings","template":"funding-tab"}}),_c('funding-tab',{attrs:{"slot":"funding-tab","fundingData":_vm.detailData},slot:"funding-tab"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }